/**
 * Configuration Manager
 * Priorität: Runtime Config (window.APP_CONFIG) > Environment Variables
 * 
 * Lösung für Server-Deployment wo .env Dateien zur Laufzeit ignoriert werden
 */

class ConfigManager {
  static getConfig() {
    const buildTimeConfig = {
      API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8082/api",
      ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "development",
      ENABLE_API_LOGGING: process.env.REACT_APP_ENABLE_API_LOGGING || "false"
    };

    const runtimeConfig = window.APP_CONFIG || {};
    const isLocalDev = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

    if (isLocalDev) {
      return {
        API_BASE_URL: buildTimeConfig.API_BASE_URL,
        ENVIRONMENT: buildTimeConfig.ENVIRONMENT,
        ENABLE_API_LOGGING: buildTimeConfig.ENABLE_API_LOGGING,
        CONFIG_SOURCE: "BUILD_TIME_DEV",
        LOADED_AT: "BUILD_TIME"
      };
    }

    return {
      API_BASE_URL: runtimeConfig.API_BASE_URL || buildTimeConfig.API_BASE_URL,
      ENVIRONMENT: runtimeConfig.ENVIRONMENT || buildTimeConfig.ENVIRONMENT,
      ENABLE_API_LOGGING: runtimeConfig.ENABLE_API_LOGGING || buildTimeConfig.ENABLE_API_LOGGING,
      CONFIG_SOURCE: runtimeConfig.API_BASE_URL ? "RUNTIME_ENV" : "BUILD_TIME_FALLBACK",
      LOADED_AT: runtimeConfig.LOADED_AT || "BUILD_TIME"
    };
  }
  
  static getApiBaseUrl() {
    return this.getConfig().API_BASE_URL;
  }
  
  static isLoggingEnabled() {
    const config = this.getConfig();
    return config.ENABLE_API_LOGGING === true || config.ENABLE_API_LOGGING === 'true';
  }
  
  static getEnvironment() {
    return this.getConfig().ENVIRONMENT;
  }
  
  static logConfigInfo() {
    console.group("Configuration Manager");
    console.groupEnd();
    return this.getConfig();
  }
}

export default ConfigManager;
